exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SpelInput {\n  font-family: monospace;\n}\n", ""]);

